module.exports = {
    // toggle display of definition list and relevant definition list item
    // on interaction with a sub-lane toggle button
    init: () => {
        // get all sub-lanes
        let subLanesClass = ".process_map__lane__sub_lane";
        let subLanes      = document.querySelectorAll(subLanesClass);
        if (!subLanes) {
            console.error(`Could not find any elements with the selector: ${subLanesClass}`);
            return;
        };

        // get darker overlay
        const darkerOverlayClass = ".darker";
        const darkerOverlay      = document.querySelector(darkerOverlayClass);
        // loop through sub-lanes
        subLanes.forEach(subLane => {
            // store this sub-lane's sibling definition container
            let definitionListClass = "process_map__definitions";
            let definitionList      = subLane.nextElementSibling;
            if (!definitionList) {
                console.error(`Could not find a sub-lane sibling definition container with the selector: ${definitionListClass}`);
                return;
            };
            // check that the sibling definition container we've stored is the correct element
            if (!definitionList.classList.contains(definitionListClass)) {
                console.error("This sub-lane is missing a sibling definition container");
            }
            // declare the class that shows the definition container
            let definitionListOpenClass = "process_map__definitions--is_visible";
            // store all of the definition list items
            let definitionListItemsClass = ".process_map__definitions__item";
            let definitionListItems      = definitionList.querySelectorAll(definitionListItemsClass);
            if (!definitionListItems) {
                console.error(`Could not find any definition list items with the selector: ${definitionListItemsClass}`);
                return;
            };
            // declare the class that shows the definition list item
            let definitionListItemActiveClass = "process_map__definitions__item--active";
            // store all of this sub-lane's definition toggle buttons
            let toggleButtonsClass = ".process_map__lane__sub_lane__toggle";
            let toggleButtons      = subLane.querySelectorAll(toggleButtonsClass);
            if (!toggleButtons) {
                console.error(`Could not find any of this sub-lane's definition toggle buttons with the selector: ${toggleButtonsClass}`);
                return;
            };
            // declare the class that allows us to target active node toggle buttons
            let toggleButtonsActiveClass = "process_map__lane__sub_lane__toggle--active";
            // loop through this sub-lane's definition toggle buttons
            toggleButtons.forEach(toggleButton => {
                // declare the name of the data attribute
                let dataID = "data-definition-id";
                // get this toggle button's ID
                let toggleButtonID = toggleButton.getAttribute(dataID);
                // listen for this button to be clicked
                toggleButton.addEventListener("click", function (event) {
                    // remove the active class from every other button in this sub-lane
                    toggleButtons.forEach(toggleButton => {
                        toggleButton.classList.remove(toggleButtonsActiveClass);
                    });
                    // add darken class to overlay
                    darkerOverlay.classList.add("darken");
                    // loop through definition list items to find one with the matching ID
                    definitionListItems.forEach(definitionListItem => {
                        let listItemID = definitionListItem.getAttribute(dataID);
                        if (listItemID === toggleButtonID) {
                            // declare empty variables which will be populated later if elements are visible
                            let listIsOpen       = false;
                            let listItemIsActive = false;
                            // check if the sibling definition container is open
                            if (definitionList.classList.contains(definitionListOpenClass)) {
                                listIsOpen = true;
                            }
                            // check whether the definition list item with the matching id is already visible
                            if (definitionListItem.classList.contains(definitionListItemActiveClass)) {
                                listItemIsActive = true;
                            }
                            // if both of the above are true, remove visible class from everything in this container and the container itself
                            if (listIsOpen === true && listItemIsActive === true) {
                                // remove darken class from darker overlay
                                darkerOverlay.classList.remove("darken");
                                // remove visible class from this definition list
                                definitionList.classList.remove(definitionListOpenClass);
                                // remove visible class from all of this definition list's items
                                definitionListItems.forEach(definitionListItem => {
                                    definitionListItem.classList.remove(definitionListItemActiveClass);
                                });
                            } else {
                                // if the definition container is not open, open it
                                if (listIsOpen === false) {
                                    definitionList.classList.add(definitionListOpenClass);
                                }
                                // remove visible class from all definition list items
                                definitionListItems.forEach(definitionListItem => {
                                    definitionListItem.classList.remove(definitionListItemActiveClass);
                                });
                                // add the active class to this button
                                toggleButton.classList.add(toggleButtonsActiveClass);
                                // add visible class to the matching definition item
                                definitionListItem.classList.add(definitionListItemActiveClass);
                            }
                        }
                    });
                }, false);
            });
        });
    }
};
